export default __webpack_public_path__ + "static/media/headerBanner.e6085a8b.png";